import React from "react";
import Styles from "./styles.module.scss";
import { useSelector } from "react-redux";
import {useTranslation} from "react-i18next";

const TripleArrowRight = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="19" height="11" viewBox="0 0 19 11" fill="none">
        <path d="M0.43091 10.6478C-0.120162 10.1567 -0.146401 9.33292 0.373658 8.81013L2.82843 6.33654C3.33179 5.8296 3.32464 5.03525 2.81173 4.53736L0.411828 2.2086C-0.117773 1.69488 -0.108232 0.873363 0.433298 0.370949C0.974827 -0.131464 1.8408 -0.122412 2.3704 0.391317L6.60959 4.50341C7.1225 5.0013 7.13204 5.79565 6.62629 6.30259L2.36801 10.5912C1.85034 11.114 0.981982 11.1389 0.43091 10.6455V10.6478Z" fill="#AFA293"/>
        <path d="M6.43091 10.6478C5.87984 10.1567 5.8536 9.33292 6.37365 8.81013L8.82843 6.33654C9.33179 5.8296 9.32463 5.03525 8.81173 4.53736L6.41182 2.2086C5.88222 1.69488 5.89177 0.873363 6.43329 0.370949C6.97482 -0.131464 7.84079 -0.122412 8.37039 0.391317L12.6096 4.50341C13.1225 5.0013 13.132 5.79565 12.6263 6.30259L8.36801 10.5912C7.85034 11.114 6.98199 11.1389 6.43091 10.6455V10.6478Z" fill="#AFA293"/>
        <path d="M12.4309 10.6478C11.8798 10.1567 11.8536 9.33292 12.3737 8.81013L14.8284 6.33654C15.3318 5.8296 15.3246 5.03525 14.8117 4.53736L12.4118 2.2086C11.8822 1.69488 11.8918 0.873363 12.4333 0.370949C12.9748 -0.131464 13.8408 -0.122412 14.3704 0.391317L18.6096 4.50341C19.1225 5.0013 19.132 5.79565 18.6263 6.30259L14.368 10.5912C13.8503 11.114 12.982 11.1389 12.4309 10.6455V10.6478Z" fill="#AFA293"/>
    </svg>
);

const ArrowDown = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="11" height="19" viewBox="0 0 11 19" fill="none">
        <path d="M0.352211 0.43091C0.843308 -0.120162 1.66708 -0.146401 2.18987 0.373658L4.66346 2.82843C5.1704 3.33179 5.96475 3.32464 6.46264 2.81173L8.7914 0.411828C9.30512 -0.117773 10.1266 -0.108232 10.6291 0.433298C11.1315 0.974827 11.1224 1.8408 10.6087 2.3704L6.49659 6.60959C5.9987 7.12249 5.20435 7.13204 4.69741 6.62629L0.408789 2.36801C-0.113993 1.85034 -0.138885 0.981981 0.354476 0.43091L0.352211 0.43091Z" fill="#AFA293"/>
        <path d="M0.352211 6.43091C0.843308 5.87984 1.66708 5.8536 2.18987 6.37365L4.66346 8.82843C5.1704 9.33179 5.96475 9.32463 6.46264 8.81173L8.7914 6.41182C9.30512 5.88222 10.1266 5.89177 10.6291 6.43329C11.1315 6.97482 11.1224 7.84079 10.6087 8.37039L6.49659 12.6096C5.9987 13.1225 5.20435 13.132 4.69741 12.6263L0.408789 8.36801C-0.113993 7.85034 -0.138885 6.98198 0.354476 6.43091L0.352211 6.43091Z" fill="#AFA293"/>
        <path d="M0.352211 12.4309C0.843308 11.8798 1.66708 11.8536 2.18987 12.3737L4.66346 14.8284C5.1704 15.3318 5.96475 15.3246 6.46264 14.8117L8.7914 12.4118C9.30512 11.8822 10.1266 11.8918 10.6291 12.4333C11.1315 12.9748 11.1224 13.8408 10.6087 14.3704L6.49659 18.6096C5.9987 19.1225 5.20435 19.132 4.69741 18.6263L0.408789 14.368C-0.113993 13.8503 -0.138885 12.982 0.354476 12.4309L0.352211 12.4309Z" fill="#AFA293"/>
    </svg>
);

const RoadmapMobile = () => {
    const { t } = useTranslation();
    const roadmap = useSelector((store) => store.cabinet.roadmap);

    if (!roadmap || roadmap.length === 0) return null;

    // Разбиваем roadmap на группы по 3 элемента
    const chunkedRoadmap = [];
    for (let i = 0; i < roadmap.length; i += 3) {
        let chunk = roadmap.slice(i, i + 3);
        chunkedRoadmap.push(chunk);
    }

    return (
        <section className={Styles.container}>
            <div className={Styles.contentWrap}>
                {chunkedRoadmap.map((row, rowIndex) => {
                    // Определяем, является ли ряд чётным (нумерация rowIndex начинается с 0)
                    const isEvenRow = rowIndex % 2 === 1;
                    const orderedRow = isEvenRow ? [...row].reverse() : row;

                    return (
                        <React.Fragment key={`row-${rowIndex}`}>
                            <div className={Styles.row}>
                                {orderedRow.map((item, itemIndex) => {
                                    // Определяем правильный номер круга (Lap #)
                                    const originalIndex = rowIndex * 3 + itemIndex;
                                    const orderedIndex = isEvenRow
                                        ? rowIndex * 3 + (row.length - 1 - itemIndex)
                                        : originalIndex;

                                    return (
                                        <React.Fragment key={`roadmapMobile-${rowIndex}-${itemIndex}`}>
                                            {/* Стрелка перед каждым элементом (кроме первого в ряду) */}
                                            {itemIndex !== 0 && (
                                                <div
                                                    className={Styles.arrow}
                                                    style={{
                                                        transform: isEvenRow ? "rotate(180deg)" : "none",
                                                    }}
                                                >
                                                    <TripleArrowRight />
                                                </div>
                                            )}

                                            {/* Элемент */}
                                            <div className={`${Styles.contentWrapItem} ${item.status === 'completed' ? Styles.contentWrapItemCompleted : null} ${item.status === 'active' ? Styles.contentWrapItemActive : null}`}>
                                                <div className={Styles.roadmapWrap}>
                                                    <div className={Styles.roadmapBox}>
                                                        <div className={Styles.roadmapBoxName}>{t('Цена токена')}</div>
                                                        <div className={Styles.roadmapBoxValue}>{item.price * 1}$</div>
                                                    </div>
                                                </div>
                                                <div className={Styles.roadmapNote}>{t('Круг')} #{orderedIndex + 1}</div>
                                            </div>
                                        </React.Fragment>
                                    );
                                })}
                            </div>

                            {/* Стрелка вниз между рядами */}
                            {rowIndex !== chunkedRoadmap.length - 1 && (
                                <div className={Styles.downArrow}>
                                    <div
                                        className={Styles.downArrowPos}
                                        style={{
                                            gridColumn: rowIndex % 2 === 0 ? 5 : 1 // Чередуем на каждом ряду
                                        }}
                                    >
                                        <ArrowDown />
                                    </div>
                                </div>
                            )}

                        </React.Fragment>
                    );
                })}
                <div className={Styles.btnsWrap}>
                    <div className={Styles.arrowRow}>
                        <div className={Styles.arrowPos}>
                            <ArrowDown/>
                        </div>
                    </div>
                    <div className={Styles.listingBtn}>
                        <div className={Styles.listingBtnText}>{t('Листинг на бирже')}</div>
                    </div>
                    <div className={Styles.listingBtnNote}>{t('Итоговый результат')}</div>
                </div>
            </div>
        </section>
    );
};

export default RoadmapMobile;
